// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__1uypq","filled":"IconReviewStar_filled__3_1dq"};